import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const qualityScorecardsAccessControl: DomainAccessControlConfig = {
  permissions: Permission.AdminPanel,
}
